import React from "react";

const Register = props => (
  <svg
    width={61}
    height={61}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{`courseware/3`}</title>
    <defs>
      <path
        d="M0 29.504c0 16.099 13.05 29.149 29.149 29.149 16.098 0 29.149-13.05 29.149-29.149S45.247.355 29.149.355C13.05.355 0 13.405 0 29.504"
        id="a"
      />
      <path
        d="M0 29.504c0 16.099 13.05 29.149 29.149 29.149 16.098 0 29.149-13.05 29.149-29.149S45.247.355 29.149.355C13.05.355 0 13.405 0 29.504"
        id="c"
      />
      <path
        d="M0 29.504c0 16.099 13.05 29.149 29.149 29.149 16.098 0 29.149-13.05 29.149-29.149S45.247.355 29.149.355C13.05.355 0 13.405 0 29.504"
        id="e"
      />
      <path
        d="M0 29.504c0 16.099 13.05 29.149 29.149 29.149 16.098 0 29.149-13.05 29.149-29.149S45.247.355 29.149.355C13.05.355 0 13.405 0 29.504"
        id="g"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 .645)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          d="M38.607 41.802c-1.713-.598-3.295-1.285-4.27-2.724 2.749-3.125 4.749-8.166 4.749-12.88 0-7.547-4.591-11.389-10.254-11.389-5.662 0-10.25 3.842-10.25 11.39 0 4.707 1.997 9.747 4.74 12.872-.972 1.443-2.556 2.133-4.274 2.731C8.427 45.495 8.282 48.54 8.323 51.822H8.32V60h41.005v-7.345c0-3.61.8-6.848-10.718-10.853"
          fill="#75CFEC"
          mask="url(#b)"
        />
      </g>
      <g transform="translate(1 .645)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <path
          d="M47.128 42.831a4.86 4.86 0 1 1-9.723-.001 4.86 4.86 0 0 1 9.723.001"
          fill="#23C991"
          mask="url(#d)"
        />
      </g>
      <g transform="translate(1 .645)">
        <mask id="f" fill="#fff">
          <use xlinkHref="#e" />
        </mask>
        <path
          d="M42.268 40.566v4.53"
          stroke="#FFF"
          strokeLinecap="round"
          mask="url(#f)"
        />
      </g>
      <g transform="translate(1 .645)">
        <mask id="h" fill="#fff">
          <use xlinkHref="#g" />
        </mask>
        <path
          d="M44.533 42.831h-4.53"
          stroke="#FFF"
          strokeLinecap="round"
          mask="url(#h)"
        />
      </g>
      <path
        d="M59.298 30.15c0 16.098-13.05 29.147-29.149 29.147S1 46.248 1 30.15 14.05 1 30.15 1c16.097 0 29.148 13.05 29.148 29.15z"
        stroke="#FEAD64"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export default Register;
